import { Product } from "../../common/models/product";
import {
  getMatchAssessment,
  getMatchBadgeBars,
  MatchLevels,
} from "./helpers";

const BAR_COLOR_CLASSES: Record<string, string> = {
  green: "bg-green-500",
  yellow: "bg-yellow-500",
  red: "bg-red-500",
};

const issueDescriptions = (levels: MatchLevels): string[] => {
  const issues: string[] = [];
  if (levels.material > 0) issues.push("Not an exact material match");
  if (levels.shape > 0) issues.push("Different form than requested");
  if (levels.sizeUndersized > 0)
    issues.push("Smaller than the requested size");
  if (levels.sizeOversized > 0)
    issues.push("Larger than the requested size (can be cut down)");
  if (levels.sizeMissing > 0)
    issues.push("Does not carry the requested dimension");
  if (levels.standards > 0)
    issues.push("Requested standard/condition not confirmed");
  return issues;
};

/**
 * The Match Quality badge: 3 bars, each degrading green -> yellow -> red
 * (rightmost first) as the item violates the configured match rules. Driven by
 * the same scoring used to rank results, so bar color always agrees with the
 * item's position in the list.
 */
export const MatchQualityBadge = ({
  product,
  structuredQuery,
}: {
  product: Product;
  structuredQuery: any;
}) => {
  const assessment = getMatchAssessment(product, structuredQuery);
  const bars = getMatchBadgeBars(assessment.totalLevels);
  const issues = issueDescriptions(assessment.levels);
  const description =
    issues.length === 0 ? "Material and dimensions match" : issues.join("; ");

  return (
    <span title={description}>
      <span className="sr-only">{description}</span>
      <span className="inline-block whitespace-nowrap">
        {bars.map((color, i) => (
          <span
            key={i}
            className={`w-2 h-1 ${BAR_COLOR_CLASSES[color]} rounded-full inline-block ${
              i > 0 ? "ml-[0.1em]" : ""
            }`}
          ></span>
        ))}
      </span>
    </span>
  );
};
